import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { Gallery } from './model/gallery.model';
import { GalleryResponse } from './model/gallery-response.model';
import { GalleryService } from './services/gallery.service';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [TranslateModule, NgFor, NgIf],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.css'
})
export class GalleryComponent {

  currentLanguage: string = '';
  albumData: Gallery[] = [];
  baseApiUrl = environment.baseApiUrl;

  pagination = {
    page: 1,
    limit: 100
  }

  constructor(private translate: TranslateService, private galleryService: GalleryService) {}

  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    })

    this.loadGalleries(this.pagination.page, this.pagination.limit);
    
  }

  loadGalleries(page: number, limit: number) {
    this.galleryService.getAlbums(page, limit).subscribe(
      (Response: GalleryResponse) => {
        this.albumData = Response.data.albums.map(album => ({
          ...album
        }));
      },
      (error) => {
        console.log('Error fetching galleries: ', error);
      }
    )
  }



  // allAlbums = [
  //   {
  //     title: '5years Anniversary Celebration of NongHyup Finance (Cambodia) Plc.',
  //     titlekh: 'អបអរសាទរខួប៥ឆ្នាំ នៃគ្រឹះស្ថានមីក្រូហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន (ខេមបូឌា) ម.ក',
  //     totalAmount: 33,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/5_years_anniversary/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/1'
  //   },
  //   {
  //     title: 'NongHyup Bank, in partnership with NongHyup Finance (Cambodia), generously donates to AFESIP Cambodia on 08 August 2023.',
  //     titlekh: 'ថ្ងៃទី០៨ ខែសីហា ឆ្នាំ២០២៣ ធនាគារណុងហឹប រួមនឹងគ្រឹះស្ថានមីក្រូហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន (ខេមបូឌា) ម.ក ផ្តល់ជំនួយឧបត្តមដល់អង្គការ អាហ្វេស៊ីប កម្ពុជា',
  //     totalAmount: 31,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/afesip/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/2'
  //   },
  //   {
  //     title: 'Grand Opening of NongHyup Finance (Cambodia) Plc. Headquarters New Building',
  //     titlekh: 'ពិធីសម្ពោធ អគារថ្មីការិយាល័យកណ្តាលរបស់គ្រឹះស្ថានមីក្រូហិរញ្ញវត្ថុ ណុងហឹប ហ្វាយនែន (ខេមបូឌា) ម.ក',
  //     totalAmount: 29,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/grand_opening/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/3'
  //   },
  //   {
  //     title: 'Contribution to Trapeang Thom commune at Kampot Province',
  //     titlekh: 'ឧបត្ថម្ភសម្ភារប្រើប្រាស់ដល់សាលាឃុំត្រពាំងធំ ខេត្តកំពត',
  //     totalAmount: 11,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Contribution_to_Trapeang_Thom_commune_at_Kampot_Province/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/4'
  //   },
  //   {
  //     title: 'Staff Assembly 2022',
  //     titlekh: 'សន្និបាតបុគ្គលិក ឆ្នាំ២០២២',
  //     totalAmount: 41,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/staff_assembly_2022/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/5'
  //   },
  //   {
  //     title: 'NongHyup Finance Football Tournament 2022',
  //     titlekh: 'កម្មវិធីប្រកួតបាល់ទាត់ជម្រើសជើងឯករបស់គ្រួសារ ណុងហឹប ហ្វាយនែន',
  //     totalAmount: 31,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/NongHyup_Finance_Football_Tournament_2022/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/6'
  //   },
  //   {
  //     title: 'Cycling for Social and Charity at Siem Reap Province',
  //     titlekh: 'កម្មវិធីជិះកង់ដើម្បីសប្បុរសធម៌ និងសង្គម នៅខេត្តសៀមរាប',
  //     totalAmount: 37,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Cycling_for_Social_and_Charity_at_Siem_Reap_Province/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/7'
  //   },
  //   {
  //     title: 'Agriculture Training at Kampong Cham Provincial Branch',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាខេត្តកំពង់ចាម',
  //     totalAmount: 22,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_Kampong_Cham_Provincial_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/8'
  //   },
  //   {
  //     title: 'Blood Donation',
  //     titlekh: 'កម្មវិធីបរិច្ចាគឈាម',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Blood_Donation/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/9'
  //   },
  //   {
  //     title: 'Contribution_to_communes_at_Baray_District_Kampong_Thom_Province',
  //     titlekh: 'ការឧបត្ថម្ភដល់សាលាឃុំនៅសុ្រកបារាយណ៍ខេត្តកំពង់ធំ',
  //     totalAmount: 16,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Contribution_to_communes_at_Baray_District_Kampong_Thom_Province/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/10'
  //   },
  //   {
  //     title: 'Contribution to AFESIP',
  //     titlekh: 'ការឧបត្ថម្ភដល់អង្គការអាហ្វេស៊ីបកម្ពុជា',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Contribution_to_AFESIP/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/11'
  //   },
  //   {
  //     title: 'Contribution to MoH',
  //     titlekh: 'ការឧបត្ថម្ភដល់ក្រសួងសុខាភិបាល',
  //     totalAmount: 16,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Contribution_to_MoH/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/12'
  //   },
  //   {
  //     title: 'Agriculture Training at Kralanh District Branch',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាសុ្រកក្រឡាញ់',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_Kralanh_District_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/13'
  //   },
  //   {
  //     title: 'Agriculture Training at Kampot Provincial Branch',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាខេត្តកំពត',
  //     totalAmount: 5,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_Kampot_Provincial_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/14'
  //   },
  //   {
  //     title: 'Agriculture Training at Kep Provincial Branch',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាខេត្តកែប',
  //     totalAmount: 12,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_Kep_Provincial_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/15'
  //   },
  //   {
  //     title: 'Financial Literacy Training',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលស្តីពីចំណេះដឹងផ្នែកហិរញ្ញវត្ថុ',
  //     totalAmount: 7,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Financial_Literacy_Training/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/16'
  //   },
  //   {
  //     title: 'Staff Assembly 2018',
  //     titlekh: 'សន្និបាតបុគ្គលិក ឆ្នាំ២០១៨',
  //     totalAmount: 22,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Staff_Assembly_2018/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/17'
  //   },
  //   {
  //     title: 'School Donation at Prey Veng Province',
  //     titlekh: 'កម្មវិធីបរិច្ចាគសម្ភារសិក្សានៅខេត្តព្រៃវែង',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/School_Donation_at_Prey_Veng_Province/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/18'
  //   },
  //   {
  //     title: 'Agriculture Training at KampongThom Provincial Branch',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាខេត្តកំពង់ធំ',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_KampongThom_Provincial_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/19'
  //   },
  //   {
  //     title: 'Agriculture Training at Stueng Hav District Branch',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាសុ្រកស្ទឹងហាវ',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_Stueng_Hav_District_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/20'
  //   },
  //   {
  //     title: 'Agriculture Training at Chhouk District Branch.',
  //     titlekh: 'វគ្គបណ្តុះបណ្តាលកសិកម្មនៅសាខាសុ្រកឈូក',
  //     totalAmount: 20,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Agriculture_Training_at_Chhouk_District_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/21'
  //   },
  //   {
  //     title: 'Annual Staff Assembly 2019',
  //     titlekh: 'សន្និបាតបុគ្គលិក ឆ្នាំ២០១៩',
  //     totalAmount: 24,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Annual_Staff_Assembly_2019/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/22'
  //   },
  //   {
  //     title: 'Chairs Contribution to Authorities at Kandal Province',
  //     titlekh: 'ការឧបត្ថម្ភកៅអីដល់អាជ្ញាធរក្នុងខេត្តកណ្តាល',
  //     totalAmount: 17,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Chairs_Contribution_to_Authorities_at_Kandal_Province/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/23'
  //   },
  //   {
  //     title: "Food Supply Contribution to Clients at S' Ang District Branch",
  //     titlekh: 'ការបរិច្ចាគដល់អតិថិជន(ភ្លើងឆេះផ្ទះ)នៅសាខាសុ្រកស្អាង',
  //     totalAmount: 13,
  //     coverUrl: this.baseApiUrl + '/uploads/images/gallery/Food_Supply_Contribution_to_Clients_at_SAng_District_Branch/1.jpg',
  //     detailUrl: 'gallery/gallery-detail/24'
  //   }
  // ];
}
